module.exports = __webpack_public_path__ + "static/media/kaste.cd67bb70.m4a";